import { all, call } from 'redux-saga/effects';
import sessionSagas from './session/sagas';
import teamSagas from './team/sagas';
import organisationSagas from './organisation/sagas';
import siteSagas from './site/sagas';
import AnnouncementsSagas from './announcement/sagas';

export default function* rootSaga() {
  yield all([
    call(sessionSagas),
    call(teamSagas),
    call(organisationSagas),
    call(siteSagas),
    call(AnnouncementsSagas)
  ]);
}
